import { apiClient } from './client';

export interface Operator {
  id: string;
  username: string;
  displayName: string;
  role: 'master' | 'admin' | 'operator' | 'viewer';
  tenantId: string;
  isActive: boolean;
  lastLoginAt?: string;
  createdAt: string;
}

export interface CreateOperatorBody {
  username: string;
  password: string;
  displayName: string;
  role: 'master' | 'admin' | 'operator' | 'viewer';
}

export interface UpdateOperatorBody {
  displayName?: string;
  role?: 'master' | 'admin' | 'operator' | 'viewer';
  isActive?: boolean;
}

export const operatorsApi = {
  list: async () => {
    const { data } = await apiClient.get('/admin/operators');
    return data as Operator[];
  },

  create: async (body: CreateOperatorBody) => {
    const { data } = await apiClient.post('/admin/operators', body);
    return data as Operator;
  },

  update: async (id: string, body: UpdateOperatorBody) => {
    const { data } = await apiClient.patch(`/admin/operators/${id}`, body);
    return data as Operator;
  },

  remove: async (id: string) => {
    await apiClient.delete(`/admin/operators/${id}`);
  },
};
